// src/components/layout/Footer.jsx
import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../utils/translations';
import Container from '../common/Container';
import '../../styles/Footer.css';

const Footer = () => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const t = translations[language].footer;
    const currentYear = new Date().getFullYear();

    return (
        <footer className={`footer ${theme}`}>
            <Container>
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>{t.contact.title}</h3>
                        <ul>
                            <li>
                                <span>{t.contact.email}</span>
                                <a href="mailto:ericktorres7314@gmail.com">
                                    ericktorres7314@gmail.com
                                </a>
                            </li>
                            <li>
                                <span>{t.contact.phone}</span>
                                <a href="tel:+50688888888">+506 8888 8888</a>
                            </li>
                            <li>
                                <span>{t.contact.location}</span>
                                <span>Alajuela, Costa Rica</span>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h3>{t.quickLinks.title}</h3>
                        <ul>
                            <li><a href="#hero">{t.quickLinks.home}</a></li>
                            <li><a href="#about">{t.quickLinks.about}</a></li>
                            <li><a href="#experience">{t.quickLinks.experience}</a></li>
                            <li><a href="#projects">{t.quickLinks.projects}</a></li>
                            <li><a href="#skills">{t.quickLinks.skills}</a></li>
                            <li><a href="#certificates">{t.quickLinks.certifications}</a></li>
                            <li><a href="#contact">{t.quickLinks.contact}</a></li>
                        </ul>
                    </div>
                </div>
                
                <div className="footer-bottom">
                    <p>&copy; {currentYear} Erick Torres Hernández</p>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;